module.exports = __webpack_public_path__ + "static/media/4.d0b57dde.jpg";